import { useMemo } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

/**
 * 브랜드 랭킹 데이터를 가져오는 훅
 *
 * @param {string} filterName GraphQL 필드 이름(ex: "trendingBrands", "weeklyPopularBrands")
 * @returns {{ loading: boolean, error: any, brands: Array }}
 */
export default function useBrandRanking(filterName) {
  // filterName이 없을 때는 dummy 쿼리를 사용하고 skip 옵션을 켭니다.
  const GET_BRAND_RANKING = useMemo(() => {
    if (!filterName) {
      return gql`query { __typename }`;
    }
    return gql`
    {
      getPopularKeywordsByFilterCached {
        ${filterName} {
          id
          name_kr
          name
          resizedSmallLogo
        }
      }
    }
  `;
  }, [filterName]);

  const { loading, error, data } = useQuery(GET_BRAND_RANKING, {
    fetchPolicy: "cache-first",
    skip: !filterName,
  });

  let brands = [];
  if (
    filterName &&
    data &&
    data.getPopularKeywordsByFilterCached &&
    data.getPopularKeywordsByFilterCached[filterName]
  ) {
    brands = data.getPopularKeywordsByFilterCached[filterName];
  }

  return { loading, error, brands };
}
